<template>
  <div>
    <Header :title="title"></Header>
    <NOdata v-if="list && this.list.length == 0" title="暂无消息"></NOdata>
    <div
      v-else
      class="jxzx infinite-list"
      v-infinite-scroll="load"
      style="overflow:auto"
      infinite-scroll-immediate="false"
    >
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="goItem(item)"
      >
        <span>[{{ flag }}]</span>
        <p>{{ item.title }}</p>
        <div class="item-content" v-html="item.wbcontent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      title: "",
      list: [],
      flag: "",
      start: 0,
      contentid: ""
    };
  },
  created() {
    this.title = this.$route.query.title;

    if (this.$route.query.title == "教学通知") {
      this.contentid = "195150";
      this.flag = "通知公告";
      this.getJxtz();
    } else if (this.$route.query.title == "教学制度") {
      this.contentid = "194523";
      this.flag = "教学制度";
      this.getJxtz();
    } else if (this.$route.query.title == "教学新闻") {
      this.contentid = "194718";
      this.flag = "教学新闻";
      this.getJxtz();
    }
  },
  methods: {
    goItem(item) {
      this.$router.push({
        path: "/jxzx/item",
        query: {
          wbnewsid: item.id
        }
      });
    },
    load() {
      this.start += 5;
      this.getJxtz();
    },
    async getJxtz() {
      const res = await Api.getVsbList({
        contentid: this.contentid,
        ownerid: "1664271694",
        start: this.start,
        count: "5"
      });

      this.list.push(...res.data);
    }
  }
};
</script>
<style lang="less" scoped>
.item-content /deep/img {
  width: 100% !important;
  height: auto !important;
}
.item-content /deep/table {
  width: 100% !important;
}
.jxzx {
  padding: 5% 5% 0;
  overflow: auto;
  height: 90vh;
  .item {
    background: #f8f8f8;
    border-radius: 5px;
    margin: 0 auto 5%;
    padding: 3% 6% 3% 6%;
    box-sizing: border-box;
    & > span {
      color: #227bc7;
      margin-bottom: 15px;
      display: block;
    }
    & > p {
      font-family: SourceHanSansCN-Medium;
      font-size: 20px;
      color: #272727;
      letter-spacing: 0;
      font-weight: bold;
      margin-bottom: 10px;
    }
    & > div {
      font-family: SourceHanSansCN-Regular;
      font-size: 16px;
      color: #959595;
      letter-spacing: 0;
      line-height: 25px;
      overflow: hidden;
      & > i {
        font-style: normal;
        color: #3eb6e4;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/jxzx/index.vue